module.exports = __webpack_public_path__ + "img/logo.5aa745c5.svg";